import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Run away church",
  "description": "",
  "published": "2007-02-13T00:00:00.000Z",
  "redirect_from": ["/blog/run-away-church/swizec/289"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wow, haven't spoken here in a while, must've slipped my mind or something. Well anyhow, here we have a video of a church running away from its neighbours, poor thing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      